// Author YuJiaBei
// Date 2022-02-07 20:53:10

import * as model from "@/model/em/opcClient/EmOpcComputedEventEoceModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmOpcComputedEventEoce(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_OPCCLIENT_URL,
    })
    .buildStore()
